// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-light: #eef2ff;
  --success-color: #10b981;
  --danger-color: #ef4444;
  --warning-color: #f59e0b;
  --text-dark: #1f2937;
  --text-medium: #4b5563;
  --text-light: #9ca3af;
  --bg-light: #f9fafb;
  --card-bg: #ffffff;
  --border-light: #e5e7eb;
  --border-radius: 12px;
  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  --transition: all 0.3s ease;
}

.company-detail-container {
  padding: 1rem;
  background-color: #f4f6f8;
  display: flex;
}

.company-card {
  background-color: var(--card-bg);
  border-radius: var(--border-radius-primary);
  box-shadow: var(--box-shadow);
  width: 100%;
  padding: 2rem;
}

.company-header {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid var(--border-light);
}

.tabs-navigation {
  display: inline-flex;
  gap: 0.5rem;
  margin-top: 2rem;
  margin-bottom: 0;
  margin-left: auto;
  margin-right: auto;
  border-bottom: none;
  padding: 0.5rem;
  background-color: #e8ecef;
  border-radius: 8px;
  width: fit-content;
  display: flex;
  justify-content: center;
}
.tabs-navigation .tab-btn {
  padding: 0.75rem 1.75rem;
  background: transparent;
  border: none;
  color: #6b7280;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 6px;
  white-space: nowrap;
}
.tabs-navigation .tab-btn:hover:not(.active) {
  color: #374151;
  background-color: rgba(255, 255, 255, 0.5);
}
.tabs-navigation .tab-btn.active {
  color: #1f2937;
  background-color: #ffffff;
  font-weight: 600;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
}

.tab-content {
  min-height: 300px;
  animation: fadeIn 0.3s ease-in;
}
.tab-content .coming-soon {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
}
.tab-content .coming-soon p {
  font-size: 1.1rem;
  color: var(--text-medium);
  font-style: italic;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.avatar {
  width: 64px;
  height: 64px;
  background-color: var(--primary-light);
  color: var(--primary-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  font-weight: bold;
  margin-right: 1.5rem;
}

.company-title h2 {
  margin: 0;
  color: var(--text-dark);
  font-size: 1.5rem;
  font-weight: 600;
}

.company-status {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 500;
  margin-top: 0.5rem;
}
.company-status.active {
  background-color: rgba(16, 185, 129, 0.1);
  color: var(--success-color);
}
.company-status.inactive {
  background-color: rgba(239, 68, 68, 0.1);
  color: var(--danger-color);
}

.company-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.detail-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}
.detail-item .icon {
  color: var(--primary-color);
  font-size: 1.25rem;
  margin-top: 0.25rem;
  flex-shrink: 0;
}
.detail-item label {
  display: block;
  color: var(--text-light);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
}
.detail-item p {
  margin: 0;
  color: var(--text-dark);
  font-size: 0.95rem;
  font-weight: 500;
}
.detail-item p a {
  color: var(--primary-color);
  text-decoration: none;
}
.detail-item p a:hover {
  text-decoration: underline;
}

.role-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
}
.role-badge.enabled {
  background-color: rgba(16, 185, 129, 0.1);
  color: var(--success-color);
}
.role-badge.disabled {
  background-color: rgba(239, 68, 68, 0.1);
  color: var(--danger-color);
}
.role-badge.success {
  background-color: rgba(16, 185, 129, 0.1);
  color: var(--success-color);
}
.role-badge.pending {
  background-color: rgba(245, 158, 11, 0.1);
  color: var(--warning-color);
}

.payment-status {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
}
.payment-status.success {
  background-color: rgba(34, 197, 94, 0.1);
  color: #16a34a;
  border: 1px solid rgba(34, 197, 94, 0.2);
}
.payment-status.pending {
  background-color: rgba(251, 191, 36, 0.1);
  color: #d97706;
  border: 1px solid rgba(251, 191, 36, 0.2);
}
.payment-status.failed {
  background-color: rgba(239, 68, 68, 0.1);
  color: #dc2626;
  border: 1px solid rgba(239, 68, 68, 0.2);
}
.payment-status.free-trial {
  background-color: rgba(59, 130, 246, 0.1);
  color: #2563eb;
  border: 1px solid rgba(59, 130, 246, 0.2);
}
.payment-status.unknown {
  background-color: rgba(107, 114, 128, 0.1);
  color: #6b7280;
  border: 1px solid rgba(107, 114, 128, 0.2);
}

.company-permissions-section {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid var(--border-light);
}
.company-permissions-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}
.company-permissions-section .section-header .section-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.company-permissions-section .section-header .section-title .icon {
  color: var(--primary-color);
  font-size: 1.25rem;
}
.company-permissions-section .section-header .section-title h3 {
  margin: 0;
  color: var(--text-dark);
  font-size: 1.25rem;
  font-weight: 600;
}

.permissions-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(200px, 1fr));
  gap: 1rem;
}
.permissions-grid .permission-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background-color: white;
  border: 1px solid var(--border-light);
  border-radius: 8px;
  transition: var(--transition);
}
.permissions-grid .permission-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.permissions-grid .permission-item .permission-details {
  flex: 1 1;
}
.permissions-grid .permission-item .permission-details .permission-name {
  font-weight: 600;
  color: var(--text-dark);
  font-size: 0.95rem;
}
.permissions-grid .permission-item .toggle-switch {
  position: relative;
  width: 50px;
  height: 24px;
  cursor: default;
}
.permissions-grid .permission-item .toggle-switch input {
  opacity: 0;
  position: absolute;
  width: 0;
  height: 0;
}
.permissions-grid .permission-item .toggle-switch input:checked + .slider {
  background-color: var(--primary-color, #3b82f6);
}
.permissions-grid .permission-item .toggle-switch input:checked + .slider::before {
  transform: translateX(26px);
}
.permissions-grid .permission-item .toggle-switch .slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #d1d5db;
  border-radius: 24px;
  transition: all 0.3s ease;
}
.permissions-grid .permission-item .toggle-switch .slider::before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  top: 3px;
  background-color: white;
  border-radius: 50%;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.court-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
}
.court-details-grid .court-detail-item {
  padding: 1rem;
  background-color: white;
  border: 1px solid var(--border-light);
  border-radius: 8px;
  transition: var(--transition);
}
.court-details-grid .court-detail-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.court-details-grid .court-detail-item .court-name {
  font-weight: 600;
  color: var(--text-dark);
  font-size: 1rem;
  margin-bottom: 0.5rem;
}
.court-details-grid .court-detail-item .court-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.court-details-grid .court-detail-item .court-info .court-state,
.court-details-grid .court-detail-item .court-info .court-code {
  font-size: 0.85rem;
  color: var(--text-medium);
}

.unique-names-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.75rem;
}
.unique-names-grid .unique-name-item {
  padding: 0.75rem 1rem;
  background-color: var(--primary-light);
  color: var(--primary-color);
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.9rem;
  text-align: center;
  transition: var(--transition);
}
.unique-names-grid .unique-name-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(67, 97, 238, 0.15);
}

.subscription-details {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
}
.subscription-details .subscription-item label {
  display: block;
  color: var(--text-light);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
}
.subscription-details .subscription-item p {
  margin: 0;
  color: var(--text-dark);
  font-size: 0.95rem;
  font-weight: 500;
}

.company-actions {
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid var(--border-light);
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
}
.company-actions .edit-company-btn,
.company-actions .back-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition);
  border: none;
}
.company-actions .edit-company-btn {
  background-color: var(--primary-color);
  color: white;
}
.company-actions .edit-company-btn:hover {
  background-color: #3c5ce6;
  transform: translateY(-1px);
}
.company-actions .back-btn {
  background-color: transparent;
  color: var(--text-medium);
  border: 1px solid var(--border-light);
}
.company-actions .back-btn:hover {
  background-color: var(--bg-light);
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(67, 97, 238, 0.2);
  border-top-color: var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

.error-message {
  color: var(--danger-color);
  font-size: 1rem;
  padding: 2rem;
  text-align: center;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .company-detail-container {
    padding: 1rem;
  }
  .company-card {
    padding: 1.5rem;
  }
  .company-details-grid {
    grid-template-columns: 1fr;
  }
  .permissions-grid {
    grid-template-columns: 1fr;
  }
  .court-details-grid {
    grid-template-columns: 1fr;
  }
  .unique-names-grid {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  }
  .subscription-details {
    grid-template-columns: 1fr;
  }
  .company-actions {
    flex-direction: column;
  }
  .company-actions .edit-company-btn,
  .company-actions .back-btn {
    justify-content: center;
  }
}
@media (max-width: 480px) {
  .company-header {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }
  .company-header .avatar {
    margin-right: 0;
  }
  .detail-item .icon {
    margin-top: 0;
  }
  .permission-item {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
    text-align: center;
  }
  .permission-item .permission-icon {
    align-self: center;
  }
  .court-detail-item {
    text-align: center;
  }
}
.login-logs-section {
  padding: 1.5rem;
  margin-top: 20px;
}
.login-logs-section .logs-loading {
  text-align: center;
  padding: 3rem;
  color: var(--text-medium);
  font-size: 1rem;
}
.login-logs-section .logs-table-container {
  background: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
.login-logs-section .logs-table-container .no-data-message {
  text-align: center;
  padding: 3rem 1rem;
}
.login-logs-section .logs-table-container .no-data-message p {
  font-size: 1rem;
  color: #6b7280;
  margin-bottom: 1.5rem;
}
.login-logs-section .logs-table-container .logs-table {
  width: 100%;
  border-collapse: collapse;
  background-color: white;
}
.login-logs-section .logs-table-container .logs-table thead {
  background-color: #f8fafc;
  border-bottom: 2px solid #e2e8f0;
}
.login-logs-section .logs-table-container .logs-table thead tr th {
  padding: 1rem;
  text-align: left;
  font-weight: 600;
  color: #475569;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;
}
.login-logs-section .logs-table-container .logs-table tbody tr {
  border-bottom: 1px solid #e2e8f0;
  transition: background-color 0.2s ease;
}
.login-logs-section .logs-table-container .logs-table tbody tr:hover {
  background-color: #f8fafc;
}
.login-logs-section .logs-table-container .logs-table tbody tr:last-child {
  border-bottom: none;
}
.login-logs-section .logs-table-container .logs-table tbody tr td {
  padding: 1rem;
  color: #334155;
  font-size: 0.9375rem;
  vertical-align: middle;
}
.login-logs-section .logs-table-container .logs-table tbody tr td .log-type,
.login-logs-section .logs-table-container .logs-table tbody tr td .log-status {
  padding: 0.375rem 0.75rem;
  border-radius: 6px;
  font-size: 0.8125rem;
  font-weight: 500;
  text-transform: capitalize;
  display: inline-block;
  white-space: nowrap;
}
.login-logs-section .logs-table-container .logs-table tbody tr td .log-type {
  background-color: #e0e7ff;
  color: #4338ca;
}
.login-logs-section .logs-table-container .logs-table tbody tr td .log-type.whatsapp {
  background-color: #dcfce7;
  color: #16a34a;
}
.login-logs-section .logs-table-container .logs-table tbody tr td .log-type.web {
  background-color: #dbeafe;
  color: #2563eb;
}
.login-logs-section .logs-table-container .logs-table tbody tr td .log-type.mobile {
  background-color: #fce7f3;
  color: #db2777;
}
.login-logs-section .logs-table-container .logs-table tbody tr td .log-status.success {
  background-color: #d1fae5;
  color: #065f46;
}
.login-logs-section .logs-table-container .logs-table tbody tr td .log-status.failure, .login-logs-section .logs-table-container .logs-table tbody tr td .log-status.failed {
  background-color: #fee2e2;
  color: #991b1b;
}
.login-logs-section .logs-table-container .logs-table tbody tr td .log-status.pending {
  background-color: #fef3c7;
  color: #92400e;
}

@media (max-width: 768px) {
  .login-logs-section {
    padding: 1rem;
  }
  .login-logs-section .logs-table-container .logs-table {
    font-size: 0.875rem;
  }
  .login-logs-section .logs-table-container .logs-table thead tr th,
  .login-logs-section .logs-table-container .logs-table tbody tr td {
    padding: 0.75rem 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/CompanyDetailsPage/CompanyDetailsPage.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,wBAAA;EACA,uBAAA;EACA,wBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,4CAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,aAAA;AACF;;AAGA;EACE,gCAAA;EACA,2CAAA;EACA,6BAAA;EACA,WAAA;EACA,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,4CAAA;AAAF;;AAGA;EACE,oBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;AAAF;AAEE;EACE,wBAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAAJ;AAEI;EACE,cAAA;EACA,0CAAA;AAAN;AAGI;EACE,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,uEAAA;AADN;;AAMA;EACE,iBAAA;EACA,8BAAA;AAHF;AAKE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AAHJ;AAKI;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;AAHN;;AAQA;EACE;IACE,UAAA;IACA,2BAAA;EALF;EAOA;IACE,UAAA;IACA,wBAAA;EALF;AACF;AAQA;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;AANF;;AAUE;EACE,SAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;AAPJ;;AAWA;EACE,qBAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AARF;AAUE;EACE,yCAAA;EACA,2BAAA;AARJ;AAWE;EACE,wCAAA;EACA,0BAAA;AATJ;;AAaA;EACE,aAAA;EACA,4DAAA;EACA,WAAA;EACA,mBAAA;AAVF;;AAaA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAVF;AAYE;EACE,2BAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAVJ;AAaE;EACE,cAAA;EACA,wBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;AAXJ;AAcE;EACE,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAZJ;AAcI;EACE,2BAAA;EACA,qBAAA;AAZN;AAcM;EACE,0BAAA;AAZR;;AAkBA;EACE,qBAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAfF;AAiBE;EACE,yCAAA;EACA,2BAAA;AAfJ;AAkBE;EACE,wCAAA;EACA,0BAAA;AAhBJ;AAmBE;EACE,yCAAA;EACA,2BAAA;AAjBJ;AAoBE;EACE,yCAAA;EACA,2BAAA;AAlBJ;;AAuBA;EAQE,qBAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AA3BF;AA6BE;EACE,wCAAA;EACA,cAAA;EACA,wCAAA;AA3BJ;AA8BE;EACE,yCAAA;EACA,cAAA;EACA,yCAAA;AA5BJ;AA+BE;EACE,wCAAA;EACA,cAAA;EACA,wCAAA;AA7BJ;AAgCE;EACE,yCAAA;EACA,cAAA;EACA,yCAAA;AA9BJ;AAiCE;EACE,0CAAA;EACA,cAAA;EACA,0CAAA;AA/BJ;;AAoCA;EACE,gBAAA;EACA,iBAAA;EACA,yCAAA;AAjCF;AAmCE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;AAjCJ;AAmCI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAjCN;AAmCM;EACE,2BAAA;EACA,kBAAA;AAjCR;AAoCM;EACE,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAlCR;;AAwCA;EACE,aAAA;EACA,oDAAA;EACA,SAAA;AArCF;AAuCE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,qCAAA;EACA,kBAAA;EACA,6BAAA;AArCJ;AAuCI;EACE,yCAAA;AArCN;AAwCI;EACE,SAAA;AAtCN;AAwCM;EACE,gBAAA;EACA,uBAAA;EACA,kBAAA;AAtCR;AAgFI;EACF,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AA9EF;AAgFE;EACE,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AA9EJ;AAgFI;EACE,+CAAA;AA9EN;AAgFM;EACE,2BAAA;AA9ER;AAmFE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,yBAAA;AAjFJ;AAmFI;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,wCAAA;AAjFN;;AAyFA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AAtFF;AAwFE;EACE,aAAA;EACA,uBAAA;EACA,qCAAA;EACA,kBAAA;EACA,6BAAA;AAtFJ;AAwFI;EACE,yCAAA;AAtFN;AAyFI;EACE,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,qBAAA;AAvFN;AA0FI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAxFN;AA0FM;;EAEE,kBAAA;EACA,yBAAA;AAxFR;;AA+FA;EACE,aAAA;EACA,2DAAA;EACA,YAAA;AA5FF;AA8FE;EACE,qBAAA;EACA,sCAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,6BAAA;AA5FJ;AA8FI;EACE,2BAAA;EACA,6CAAA;AA5FN;;AAkGA;EACE,aAAA;EACA,2DAAA;EACA,WAAA;AA/FF;AAkGI;EACE,cAAA;EACA,wBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;AAhGN;AAmGI;EACE,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAjGN;;AAsGA;EACE,gBAAA;EACA,iBAAA;EACA,yCAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;AAnGF;AAqGE;;EAEE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,YAAA;AAnGJ;AAsGE;EACE,sCAAA;EACA,YAAA;AApGJ;AAsGI;EACE,yBAAA;EACA,2BAAA;AApGN;AAwGE;EACE,6BAAA;EACA,yBAAA;EACA,qCAAA;AAtGJ;AAwGI;EACE,iCAAA;AAtGN;;AA2GA;EACE,WAAA;EACA,YAAA;EACA,wCAAA;EACA,sCAAA;EACA,kBAAA;EACA,kCAAA;EACA,cAAA;AAxGF;;AA2GA;EACE,0BAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AAxGF;;AA2GA;EACE;IACE,yBAAA;EAxGF;AACF;AA4GA;EACE;IACE,aAAA;EA1GF;EA6GA;IACE,eAAA;EA3GF;EA8GA;IACE,0BAAA;EA5GF;EA+GA;IACE,0BAAA;EA7GF;EAgHA;IACE,0BAAA;EA9GF;EAiHA;IACE,2DAAA;EA/GF;EAkHA;IACE,0BAAA;EAhHF;EAmHA;IACE,sBAAA;EAjHF;EAmHE;;IAEE,uBAAA;EAjHJ;AACF;AAqHA;EACE;IACE,sBAAA;IACA,kBAAA;IACA,SAAA;EAnHF;EAqHE;IACE,eAAA;EAnHJ;EAwHE;IACE,aAAA;EAtHJ;EA0HA;IACE,sBAAA;IACA,SAAA;IACA,oBAAA;IACA,kBAAA;EAxHF;EA0HE;IACE,kBAAA;EAxHJ;EA4HA;IACE,kBAAA;EA1HF;AACF;AA8HA;EACE,eAAA;EACA,gBAAA;AA5HF;AA8HE;EACE,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,eAAA;AA5HJ;AA+HE;EACE,iBAAA;EACA,qBAAA;EACA,wCAAA;EACA,gBAAA;AA7HJ;AA+HI;EACE,kBAAA;EACA,kBAAA;AA7HN;AA+HM;EACE,eAAA;EACA,cAAA;EACA,qBAAA;AA7HR;AAiII;EACE,WAAA;EACA,yBAAA;EACA,uBAAA;AA/HN;AAiIM;EACE,yBAAA;EACA,gCAAA;AA/HR;AAiIQ;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;AA/HV;AAoIQ;EACE,gCAAA;EACA,sCAAA;AAlIV;AAoIU;EACE,yBAAA;AAlIZ;AAqIU;EACE,mBAAA;AAnIZ;AAsIU;EACE,aAAA;EACA,cAAA;EACA,oBAAA;EACA,sBAAA;AApIZ;AAsIY;;EAEE,yBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,0BAAA;EACA,qBAAA;EACA,mBAAA;AApId;AAuIY;EACE,yBAAA;EACA,cAAA;AArId;AAuIc;EACE,yBAAA;EACA,cAAA;AArIhB;AAwIc;EACE,yBAAA;EACA,cAAA;AAtIhB;AAyIc;EACE,yBAAA;EACA,cAAA;AAvIhB;AA4Ic;EACE,yBAAA;EACA,cAAA;AA1IhB;AA6Ic;EAEE,yBAAA;EACA,cAAA;AA5IhB;AA+Ic;EACE,yBAAA;EACA,cAAA;AA7IhB;;AAwJA;EACE;IACE,aAAA;EArJF;EAwJI;IACE,mBAAA;EAtJN;EAwJM;;IAEE,uBAAA;EAtJR;AACF","sourcesContent":[":root {\n  --primary-light: #eef2ff;\n  --success-color: #10b981;\n  --danger-color: #ef4444;\n  --warning-color: #f59e0b;\n  --text-dark: #1f2937;\n  --text-medium: #4b5563;\n  --text-light: #9ca3af;\n  --bg-light: #f9fafb;\n  --card-bg: #ffffff;\n  --border-light: #e5e7eb;\n  --border-radius: 12px;\n  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n  --transition: all 0.3s ease;\n}\n\n.company-detail-container {\n  padding: 1rem;\n  background-color: #f4f6f8;\n  display: flex;\n  // min-height: 100vh;\n}\n\n.company-card {\n  background-color: var(--card-bg);\n  border-radius: var(--border-radius-primary);\n  box-shadow: var(--box-shadow);\n  width: 100%;\n  padding: 2rem;\n}\n\n.company-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 2rem;\n  padding-bottom: 1.5rem;\n  border-bottom: 1px solid var(--border-light);\n}\n\n.tabs-navigation {\n  display: inline-flex;\n  gap: 0.5rem;\n  margin-top: 2rem;\n  margin-bottom: 0;\n  margin-left: auto;\n  margin-right: auto;\n  border-bottom: none;\n  padding: 0.5rem;\n  background-color: #e8ecef;\n  border-radius: 8px;\n  width: fit-content;\n  display: flex;\n  justify-content: center;\n\n  .tab-btn {\n    padding: 0.75rem 1.75rem;\n    background: transparent;\n    border: none;\n    color: #6b7280;\n    font-size: 0.95rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    border-radius: 6px;\n    white-space: nowrap;\n\n    &:hover:not(.active) {\n      color: #374151;\n      background-color: rgba(255, 255, 255, 0.5);\n    }\n\n    &.active {\n      color: #1f2937;\n      background-color: #ffffff;\n      font-weight: 600;\n      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);\n    }\n  }\n}\n\n.tab-content {\n  min-height: 300px;\n  animation: fadeIn 0.3s ease-in;\n\n  .coming-soon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 300px;\n    \n    p {\n      font-size: 1.1rem;\n      color: var(--text-medium);\n      font-style: italic;\n    }\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.avatar {\n  width: 64px;\n  height: 64px;\n  background-color: var(--primary-light);\n  color: var(--primary-color);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.75rem;\n  font-weight: bold;\n  margin-right: 1.5rem;\n}\n\n.company-title {\n  h2 {\n    margin: 0;\n    color: var(--text-dark);\n    font-size: 1.5rem;\n    font-weight: 600;\n  }\n}\n\n.company-status {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  margin-top: 0.5rem;\n\n  &.active {\n    background-color: rgba(16, 185, 129, 0.1);\n    color: var(--success-color);\n  }\n\n  &.inactive {\n    background-color: rgba(239, 68, 68, 0.1);\n    color: var(--danger-color);\n  }\n}\n\n.company-details-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.detail-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n\n  .icon {\n    color: var(--primary-color);\n    font-size: 1.25rem;\n    margin-top: 0.25rem;\n    flex-shrink: 0;\n  }\n\n  label {\n    display: block;\n    color: var(--text-light);\n    font-size: 0.75rem;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-bottom: 0.25rem;\n  }\n\n  p {\n    margin: 0;\n    color: var(--text-dark);\n    font-size: 0.95rem;\n    font-weight: 500;\n\n    a {\n      color: var(--primary-color);\n      text-decoration: none;\n      \n      &:hover {\n        text-decoration: underline;\n      }\n    }\n  }\n}\n\n.role-badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  font-weight: 500;\n\n  &.enabled {\n    background-color: rgba(16, 185, 129, 0.1);\n    color: var(--success-color);\n  }\n\n  &.disabled {\n    background-color: rgba(239, 68, 68, 0.1);\n    color: var(--danger-color);\n  }\n\n  &.success {\n    background-color: rgba(16, 185, 129, 0.1);\n    color: var(--success-color);\n  }\n\n  &.pending {\n    background-color: rgba(245, 158, 11, 0.1);\n    color: var(--warning-color);\n  }\n\n}\n\n.payment-status {\n  // padding: 4px 12px;\n  // border-radius: 12px;\n  // font-size: 0.85rem;\n  // font-weight: 500;\n  // text-transform: capitalize;\n  // display: inline-block;\n\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  font-weight: 500;\n  \n  &.success {\n    background-color: rgba(34, 197, 94, 0.1);\n    color: #16a34a;\n    border: 1px solid rgba(34, 197, 94, 0.2);\n  }\n  \n  &.pending {\n    background-color: rgba(251, 191, 36, 0.1);\n    color: #d97706;\n    border: 1px solid rgba(251, 191, 36, 0.2);\n  }\n  \n  &.failed {\n    background-color: rgba(239, 68, 68, 0.1);\n    color: #dc2626;\n    border: 1px solid rgba(239, 68, 68, 0.2);\n  }\n  \n  &.free-trial {\n    background-color: rgba(59, 130, 246, 0.1);\n    color: #2563eb;\n    border: 1px solid rgba(59, 130, 246, 0.2);\n  }\n  \n  &.unknown {\n    background-color: rgba(107, 114, 128, 0.1);\n    color: #6b7280;\n    border: 1px solid rgba(107, 114, 128, 0.2);\n  }\n}\n\n// Company Permissions Section\n.company-permissions-section {\n  margin-top: 2rem;\n  padding-top: 2rem;\n  border-top: 1px solid var(--border-light);\n\n  .section-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1.5rem;\n\n    .section-title {\n      display: flex;\n      align-items: center;\n      gap: 0.75rem;\n\n      .icon {\n        color: var(--primary-color);\n        font-size: 1.25rem;\n      }\n\n      h3 {\n        margin: 0;\n        color: var(--text-dark);\n        font-size: 1.25rem;\n        font-weight: 600;\n      }\n    }\n  }\n}\n\n.permissions-grid {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(200px, 1fr));\n  gap: 1rem;\n\n  .permission-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem;\n    background-color: white;\n    border: 1px solid var(--border-light);\n    border-radius: 8px;\n    transition: var(--transition);\n\n    &:hover {\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n    }\n\n    .permission-details {\n      flex: 1;\n\n      .permission-name {\n        font-weight: 600;\n        color: var(--text-dark);\n        font-size: 0.95rem;\n      }\n    }\n\n    // .toggle-switch {\n    //   width: 50px;\n    //   height: 24px;\n    //   background-color: #ccc;\n    //   border-radius: 12px;\n    //   position: relative;\n    //   cursor: pointer;\n    //   transition: var(--transition);\n\n    //   &.enabled {\n    //     background-color: #004A9A;\n    //   }\n\n    //   &.disabled {\n    //     background-color: #9ca3af;\n    //   }\n\n    //   .toggle-slider {\n    //     width: 20px;\n    //     height: 20px;\n    //     background-color: white;\n    //     border-radius: 50%;\n    //     position: absolute;\n    //     top: 2px;\n    //     left: 2px;\n    //     transition: var(--transition);\n    //     box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n    //   }\n\n    //   &.enabled .toggle-slider {\n    //     transform: translateX(26px);\n    //   }\n\n    //   &.disabled .toggle-slider {\n    //     transform: translateX(0);\n    //   }\n    // }\n\n    .toggle-switch {\n  position: relative;\n  width: 50px;\n  height: 24px;\n  cursor: default; // Set to default as it's not interactive\n\n  input {\n    opacity: 0;\n    position: absolute;\n    width: 0;\n    height: 0;\n\n    &:checked + .slider {\n      background-color: var(--primary-color, #3b82f6);\n\n      &::before {\n        transform: translateX(26px);\n      }\n    }\n  }\n\n  .slider {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #d1d5db;\n    border-radius: 24px;\n    transition: all 0.3s ease;\n\n    &::before {\n      content: '';\n      position: absolute;\n      height: 18px;\n      width: 18px;\n      left: 3px;\n      top: 3px;\n      background-color: white;\n      border-radius: 50%;\n      transition: all 0.3s ease;\n      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n    }\n  }\n}\n  }\n}\n\n// Court Details Section\n.court-details-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1rem;\n\n  .court-detail-item {\n    padding: 1rem;\n    background-color: white;\n    border: 1px solid var(--border-light);\n    border-radius: 8px;\n    transition: var(--transition);\n\n    &:hover {\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n    }\n\n    .court-name {\n      font-weight: 600;\n      color: var(--text-dark);\n      font-size: 1rem;\n      margin-bottom: 0.5rem;\n    }\n\n    .court-info {\n      display: flex;\n      flex-direction: column;\n      gap: 0.25rem;\n\n      .court-state,\n      .court-code {\n        font-size: 0.85rem;\n        color: var(--text-medium);\n      }\n    }\n  }\n}\n\n// Unique Names Section\n.unique-names-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 0.75rem;\n\n  .unique-name-item {\n    padding: 0.75rem 1rem;\n    background-color: var(--primary-light);\n    color: var(--primary-color);\n    border-radius: 8px;\n    font-weight: 500;\n    font-size: 0.9rem;\n    text-align: center;\n    transition: var(--transition);\n\n    &:hover {\n      transform: translateY(-1px);\n      box-shadow: 0 2px 8px rgba(67, 97, 238, 0.15);\n    }\n  }\n}\n\n// Subscription Details Section\n.subscription-details {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1.5rem;\n\n  .subscription-item {\n    label {\n      display: block;\n      color: var(--text-light);\n      font-size: 0.75rem;\n      text-transform: uppercase;\n      letter-spacing: 0.5px;\n      margin-bottom: 0.25rem;\n    }\n\n    p {\n      margin: 0;\n      color: var(--text-dark);\n      font-size: 0.95rem;\n      font-weight: 500;\n    }\n  }\n}\n\n.company-actions {\n  margin-top: 2rem;\n  padding-top: 2rem;\n  border-top: 1px solid var(--border-light);\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n\n  .edit-company-btn,\n  .back-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1rem;\n    border-radius: 8px;\n    font-size: 0.9rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: var(--transition);\n    border: none;\n  }\n\n  .edit-company-btn {\n    background-color: var(--primary-color);\n    color: white;\n\n    &:hover {\n      background-color: #3c5ce6;\n      transform: translateY(-1px);\n    }\n  }\n\n  .back-btn {\n    background-color: transparent;\n    color: var(--text-medium);\n    border: 1px solid var(--border-light);\n\n    &:hover {\n      background-color: var(--bg-light);\n    }\n  }\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid rgba(67, 97, 238, 0.2);\n  border-top-color: var(--primary-color);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto;\n}\n\n.error-message {\n  color: var(--danger-color);\n  font-size: 1rem;\n  padding: 2rem;\n  text-align: center;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n// Responsive Design\n@media (max-width: 768px) {\n  .company-detail-container {\n    padding: 1rem;\n  }\n\n  .company-card {\n    padding: 1.5rem;\n  }\n\n  .company-details-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .permissions-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .court-details-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .unique-names-grid {\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  }\n\n  .subscription-details {\n    grid-template-columns: 1fr;\n  }\n\n  .company-actions {\n    flex-direction: column;\n\n    .edit-company-btn,\n    .back-btn {\n      justify-content: center;\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .company-header {\n    flex-direction: column;\n    text-align: center;\n    gap: 1rem;\n\n    .avatar {\n      margin-right: 0;\n    }\n  }\n\n  .detail-item {\n    .icon {\n      margin-top: 0;\n    }\n  }\n\n  .permission-item {\n    flex-direction: column;\n    gap: 1rem;\n    align-items: stretch;\n    text-align: center;\n\n    .permission-icon {\n      align-self: center;\n    }\n  }\n\n  .court-detail-item {\n    text-align: center;\n  }\n}\n\n// Login Logs Section\n.login-logs-section {\n  padding: 1.5rem;\n  margin-top: 20px;\n\n  .logs-loading {\n    text-align: center;\n    padding: 3rem;\n    color: var(--text-medium);\n    font-size: 1rem;\n  }\n\n  .logs-table-container {\n    background: white;\n    border-radius: 0.5rem;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n\n    .no-data-message {\n      text-align: center;\n      padding: 3rem 1rem;\n\n      p {\n        font-size: 1rem;\n        color: #6b7280;\n        margin-bottom: 1.5rem;\n      }\n    }\n\n    .logs-table {\n      width: 100%;\n      border-collapse: collapse;\n      background-color: white;\n\n      thead {\n        background-color: #f8fafc;\n        border-bottom: 2px solid #e2e8f0;\n\n        tr th {\n          padding: 1rem;\n          text-align: left;\n          font-weight: 600;\n          color: #475569;\n          font-size: 0.875rem;\n          text-transform: uppercase;\n          letter-spacing: 0.05em;\n          white-space: nowrap;\n        }\n      }\n\n      tbody {\n        tr {\n          border-bottom: 1px solid #e2e8f0;\n          transition: background-color 0.2s ease;\n\n          &:hover {\n            background-color: #f8fafc;\n          }\n\n          &:last-child {\n            border-bottom: none;\n          }\n\n          td {\n            padding: 1rem;\n            color: #334155;\n            font-size: 0.9375rem;\n            vertical-align: middle;\n\n            .log-type,\n            .log-status {\n              padding: 0.375rem 0.75rem;\n              border-radius: 6px;\n              font-size: 0.8125rem;\n              font-weight: 500;\n              text-transform: capitalize;\n              display: inline-block;\n              white-space: nowrap;\n            }\n\n            .log-type {\n              background-color: #e0e7ff;\n              color: #4338ca;\n\n              &.whatsapp {\n                background-color: #dcfce7;\n                color: #16a34a;\n              }\n\n              &.web {\n                background-color: #dbeafe;\n                color: #2563eb;\n              }\n\n              &.mobile {\n                background-color: #fce7f3;\n                color: #db2777;\n              }\n            }\n\n            .log-status {\n              &.success {\n                background-color: #d1fae5;\n                color: #065f46;\n              }\n\n              &.failure,\n              &.failed {\n                background-color: #fee2e2;\n                color: #991b1b;\n              }\n\n              &.pending {\n                background-color: #fef3c7;\n                color: #92400e;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n// Responsive styles for login logs\n@media (max-width: 768px) {\n  .login-logs-section {\n    padding: 1rem;\n\n    .logs-table-container {\n      .logs-table {\n        font-size: 0.875rem;\n\n        thead tr th,\n        tbody tr td {\n          padding: 0.75rem 0.5rem;\n        }\n      }\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
